export default __webpack_public_path__ + "static/media/MetaMask.fe66dff1.svg";